import React, { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import { connect as connectTodoSync } from 'src/store/todo';
import { useUser } from 'src/hooks/useUserInfo';
import { useParcelStore } from 'src/store/parcel';

import Tabs from '../tabs'
import Loader from '../shared/loader';

const Layout:React.FC = () => {

const navigate = useNavigate();
const { keycloak, initialized } = useKeycloak()
const room = useParcelStore((state) => state.roomData)


useEffect(() => {
  if (initialized && !keycloak.authenticated) {
    navigate('/login');
  }
  if(!keycloak?.token){
    navigate('/login');
  }
}, [initialized, keycloak, navigate]);

const user = useUser()

useEffect(() => {
  if (user?.name) {
    connectTodoSync({user:user as UserSessionJWT, room: room?.roomId});
  }
}, [user?.name, room?.roomId]);

  return (
    <div className='min-h-srceen w-full'>
     {!initialized ? <Loader /> :
      <div>
         <Outlet/>
         <div className='fixed bottom-0 left-0 right-0 z-10'>
          <Tabs/>
        </div>
      </div>
      }
    </div>
  )
}

export default Layout
